/* eslint-disable @typescript-eslint/indent */

/* Note: please be careful with indentation, we have the rule disabled because of
*  eslint not being able to properly indent js inside styled components
*/

// Core
import styled from 'styled-components';

// Config
import { BREAKPOINTS } from '../../../../../../config/screen';

// Components
import { Button } from '../../../../../../layout/elements/Button';

export const DetailsContainer = styled.div`
  background-color: ${({ theme }) => theme.color.crusherDashboard.modulesBackgroundColor};
  padding: 0.75rem 1rem 1rem;
  border-radius: 4px;
  display: flex;
  height: 100%;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem 1.25rem;
  };
`;

export const ContentContainer = styled.div`
  width: 100%;
  display: flex;
  flex: 1;
  height: 100%;
  flex-direction: column;
  gap: 12px;
  justify-content: space-between;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    gap: 18px;
  };
`;

export const CrusherStatus = styled.div`
  flex-direction: column;
  display: flex;
  row-gap: 4px;
`;

export const EquipmentStatusContainer = styled.div`
  margin-bottom: 0.4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const EquipmentName = styled.div`
  display: flex;
  align-items: center;
`;

export const LastUpdateTime = styled.span`
  font-family: ${({ theme }) => theme.font.bold};
  color: ${({ theme }) => theme.color.crusherDashboard.detailsModule.lastUpdateTimeTextColor};
`;

export const OverviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 11px;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    gap: 0;
  };
`;

export const OverviewContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  max-height: 160px;
`;

export const CrusherInfoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CloudConnectionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const CloudConnectionContent = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 4px;
`;

export const LastCloudConnection = styled.span`
  font-family: ${({ theme }) => theme.font.bold};
`;

export const TooltipIconContainer = styled.div`
  margin-top: 0.25rem;
  color: ${({ theme }) => theme.color.crusherDashboard.detailsModule.iconInfoColor};
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 6px;
  align-items: flex-end;
  width: 100%;
`;

export const AlarmButton = styled(Button)`
  position: relative;

  .alarms-indicator {
    position: absolute;
    left: 25px;
    bottom: 28px;
    width: 24px;
    height: 18px;
    color: ${({
    theme,
  }) => theme.color.crusherDashboard.detailsModule.activeAlarmTextColor};
    font-size: 12px;
    line-height: normal;
    font-family: ${({ theme }) => theme.font.medium};
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 3px;
    background-color: ${({
      theme,
    }) => theme.color.crusherDashboard.detailsModule.activeAlarmBackgroundColor};
  };
`;

export const EquipmentImageContainerBelow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: max-content;
  max-height: 220px;
  padding-bottom: 2rem;

  img {
    width: 80%;
    height: auto;
    object-fit: contain;
    border-radius: 8px;
  };
`;

export const OverviewWrapper = styled.div`
  display: flex;
  flex: 1;

  @media (min-width: ${BREAKPOINTS.md}px) {
    gap: 14px;
  };
`;

export const EquipmentImageContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: max-content;
  max-height: 220px;
  padding-bottom: 2rem;

  img {
    width: 115%;
    height: auto;
    max-height: 80%;
    object-fit: contain;
    margin-bottom: 3rem;
  };
`;

export const RegisteredMark = styled.sup`
  font-family: ${({ theme }) => theme.font.bold};
  font-size: 18px;
`;
